const API_ENDPOINTS = {
  LOGIN: '/accounts/login',
  LOGOUT: '/accounts/logout',
  // Quotations Page
  ADD_ONS: '/policy/addons',
  ADDITIONAL_COVERS: '/policy/additionalcovers',
  MOTOR_QUOTATIONS: '/policy/quotation/v2',
  PLAN_DETAILS: '/policy/details',
  AUTH: '/accounts/authtoken',
  MANUFACTURERS: '/dropdown/manufacturer',
  MODELS: '/dropdown/model',
  VARIANTS: '/dropdown/variant',
  INSURERS: '/insurer/listing',
  RTO: '/dropdown/rto',
  CPA_CHECK: '/policy/cpa',
  VAHAN_CHECK: '/policy/minimal-quote-info',
  OFFLINE_UPLOAD: '/policy/offline-upload',
  PINCODE_CMS: '/autofill/pincode',
  OCCUPATIONS: '/mapping/occupations',
  RELATIONSHIPS: '/mapping/relationships',
  MOTOR_PROPOSAL: '/policy/proposal',
  CKYC_VALIDATE: '/policy/CkycValidateInsurer',
  CKYC_NUMBER: '/policy/GetCkycNumber',
  IMAGE_RC_OCR: '/policy/prefill-data-rc',
  IMAGE_POLICY_OCR: '/policy/prefill-data-policy',
  PAYMENT_CHECK: '/policy/paymentcheck',
  HYPOTHECATION: '/policy/miscellaneous',
  // health
  HEALTH_QUOTATION: '/common/quotation',
  HEATH_ADDONS: '/common/addons-riders',
  HEALTH_PINCODE: '/common/pincode',
  HEALTH_SUMINSURED_GENRIC: '/common/list-suminsured',
  HEALTH_INSURER_LISTING: '/insurer/list-insurer',
  HEALTH_INSURANCE_LISTING: '/insurer/list-insurer-plans',

  HEALTH_QUES: '/common/question',
  HEALTH_LIST_MISCELLANEOUS: '/common/list-miscellaneous',
  HEALTH_BENEFITS: '/insurer/list-benifits',
  HEALTH_PROPOSAL: '/common/proposal',

  REGISTER_USER: '/common/register_posp/',
  GET_TRAINING_DATA: '/common/training_data/',
  VIDEO_WATCH_LOGS: '/common/video_watch_logs/',
  LOGIN_USER: '/common/login_posp/',
  VERIFY_OTP: '/common/verify_otp/',
  GET_DETAILS: '/journey/personal_details/',
  PERSONAL_DETAILS: '/common/pos_details/',
  UPDATE_USER_STATE: '/common/user_state/',
  GET_USER_STATE: '/common/user_state/',
  UPLOAD_USER_DOCUMENTS: '/journey/doc_upload/',
  GET_EXAM_QUESTIONS: '/mcq/exam_questions/',
  SUBMIT_EXAM_ANSWERS: '/mcq/exam_questions/',
  GET_USER_REMARKS: '/common/doc_submit_ans/',
  UPDATE_PAN: '/journey/update_pan/',
  UPDATE_PERSONAL_DETAILS: '/journey/personal_details/',
  GET_JOURNEY_DETAILS: '/journey/journey_state/',
  UPDATE_USER_TYPE: '/common/update_user_type/',
  GET_NETWORK_MANAGER: '/journey/get_posp_manager/',
  UPLOAD_NOC_DOCUMENT: '/common/upload_posp_noc/',
  LOGOUT_USER: '/common/logout/',
  GET_BANK_NAME: '/common/financier_data/',
  SEND_WATCH_TIME_LOGS: '/common/watch_time_logs/',
  FETCH_STAMPED_PDF: '/common/fetch_stamp_paper/',
  SEND_OTP_FOR_STAMP_PAPER: '/common/send_otp_for_stamp_paper/',
  VERIFY_OTP_FOR_STAMP_PAPER: '/common/verify_otp_for_stamp_paper/'
}

export { API_ENDPOINTS }
